import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';
import { TaskAction, TaskActionPost, TaskActionPut } from 'interfaces/taskAction.interface';
import { API } from 'constants/api.contants';


export class TaskActionService {

  static getTaskActionById(
    taskActionId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<TaskAction> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.TASK_ACTION}/${taskActionId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<TaskAction> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static getTaskActionBySector(
    sectorId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<TaskAction[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.TASK_ACTION_BY_SECTOR}/${sectorId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<TaskAction[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data.map( taskAction => { return { ...taskAction }; } ) );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }


  static putTaskAction(
    taskAction: TaskActionPut,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ) {
    return new Promise( async resolve => {
      let data: TaskActionPut | FormData = taskAction;

      const headers = await CommonGlobalService.getHeaderRequest( token );
      if ( taskAction.icon instanceof File ) {
        data = new FormData();
        data.append( 'id', taskAction.id as string );
        data.append( 'name', taskAction.name );
        data.append( 'content', taskAction.icon );
        if ( headers.headers && headers.headers[ 'Content-Type' ] ) {
          delete headers.headers[ 'Content-Type' ];
        }
      } else {
        data = taskAction;
      }

      AXIOS.put( `${API.TASK_ACTION}/${taskAction.id}`, data, headers )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static postTaskAction(
    taskAction: TaskActionPost,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ) {
    return new Promise( async resolve => {
      let data: FormData | TaskActionPost = taskAction;
      const headers = await CommonGlobalService.getHeaderRequest( token );
      const url = `${API.TASK_ACTION}?name=${ encodeURIComponent( taskAction.name ) }&idSector=${ encodeURIComponent( taskAction.idSector ) }`;

      if ( taskAction.icon instanceof File ) {
        data = new FormData();
        data.append( 'content', taskAction.icon );
        if ( headers.headers && headers.headers[ 'Content-Type' ] ) {
          delete headers.headers[ 'Content-Type' ];
        }
      }

      AXIOS.post( url, data, headers )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static deleteTaskAction(
    taskActionId: string,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<void> {
    return new Promise( async resolve => {
      AXIOS.delete( `${API.TASK_ACTION}/${taskActionId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve();
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  static checkTaskActionUsage(
    taskActionId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<{ isUsed: boolean }> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.TASK_ACTION}/${taskActionId}/usage`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<{ isUsed: boolean }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }
};